module.exports = __webpack_public_path__ + "img/1_A.a89960bf.webp";